import React from "react";
import { connect } from "react-redux";

import { getAvailableProducts, getUserIdentityAppReferrer } from "state/app/selectors";

class Accent extends React.Component {

  getActiveProducts = () => {
    const { availableProducts, match } = this.props;
    const urlProduct = match.params.product;
    if (availableProducts.includes(urlProduct)) {
      return [ urlProduct ];
    } else {
      return availableProducts;
    }
  }

  renderAccentSection = product => {

    const isActive = this.getActiveProducts().includes(product);

    const classNames = [ "app-bar__accent-section" ];
    const cssModifier = isActive ? "active" : "inactive";
    classNames.push(`app-bar__accent-section--${cssModifier}`);
    classNames.push(`app-bar__accent-section--${product}`);

    return (
      <div className={classNames.join(" ")} key={product}></div>
    );

  }

  render() {

    const appReferrer = this.props.appReferrer;
    let classNames = ["app-bar__accent"];
    if(appReferrer === process.env.REACT_APP_XPRESSIONS_APP_REFERRER || appReferrer === process.env.REACT_APP_PARENTAPPS_APP_REFERRER) {
      classNames.push("app-bar__accent-width--school_money");
    }else{
      classNames.push("app-bar__accent-width--eduspot");
    }

    return (
      <div className={classNames.join(" ")}>
        { this.props.availableProducts.map(this.renderAccentSection) }
      </div>
    );
  }

}

export default connect(
  state => ({
    availableProducts: getAvailableProducts(state),
    appReferrer: getUserIdentityAppReferrer(state)
  })
)(Accent);



// WEBPACK FOOTER //
// ./src/components/app/bar/Accent.js